/**
 * Get current domain from window location
 * @returns {string} Current domain (e.g., "haier", "haier-test", "varta")
 */
const getDomain = () => {
  const host = window.location.host;
  const dotIndex = host.indexOf(".");
  return dotIndex !== -1 ? host.slice(0, dotIndex) : host;
};

export default getDomain;








